import { API_DASHBOARD, API_URL, API_VUNGHI } from './../common';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private line_api = `${API_DASHBOARD}/linearechart`;
  private table_api=`${API_DASHBOARD}/tablechart`;
  private grid_api=`${API_DASHBOARD}/mapchart`;
  private disease_api=`${API_DASHBOARD}/get-list-disease`;
  private hospital_api=`${API_DASHBOARD}/get-list-hospital`;

  private text_api=`${API_DASHBOARD}/textbox`;
  private sync_api=`${API_DASHBOARD}/syncchart`;

  private nega_api = `${API_DASHBOARD}/negachart`;

  private vn_api = `${API_DASHBOARD}/vietnamchart`; 
  private bubble_api = `${API_DASHBOARD}/bubblechart`;

  private heat_api = `${API_DASHBOARD}/chart-matrix`; 
  
  private ucud_text_box = `${API_DASHBOARD}/ucod-textbox`; 

  private ucud_table = `${API_DASHBOARD}/ucod-board`; 
  private ucud_line = `${API_DASHBOARD}/ucod-line`; 
  private ucud_heat= `${API_DASHBOARD}/ucod-confusion-matrix`; 
   
  private sys_line_clients_api = `${API_VUNGHI}/unique_clients/`; 
  private sys_line_usages_api = `${API_VUNGHI}/unique_usage/`; 
  
  private sys_sun_api = `${API_VUNGHI}/treemap_data/`; 
  
  constructor(private http: HttpClient) { }
  sysLineClients(param:string): Observable<any[]> {
    const url = `${this.sys_line_clients_api}${param}`;
    return this.http.get<any[]>(url);
  }
  sysUsagesClients(param:string): Observable<any[]> {
    const url = `${this.sys_line_usages_api}${param}`;
    return this.http.get<any[]>(url);
  }
  sysSun(param:string): Observable<any[]> {
    const url = `${this.sys_sun_api}${param}`;
    return this.http.get<any[]>(url);
  }
  heatMap(param:string): Observable<any[]> {
    const url = `${this.heat_api}${param}`;
    return this.http.get<any[]>(url);
  }
  line(param:string): Observable<any[]> {
    const url = `${this.line_api}${param}`;
    return this.http.get<any[]>(url);
  }
  nega(param:string): Observable<any[]> {
    const url = `${this.nega_api}${param}`;
    return this.http.get<any[]>(url);
  }
  ucodTable(param:string): Observable<any[]> {
    const url = `${this.ucud_table}${param}`;
    return this.http.get<any[]>(url);
  }
  ucodLine(param:string): Observable<any[]> {
    const url = `${this.ucud_line}${param}`;
    return this.http.get<any[]>(url);
  }
  ucodHeatMap(param:string): Observable<any[]> {
    const url = `${this.ucud_heat}${param}`;
    return this.http.get<any[]>(url);
  }
  ucodTextbox(param:string): Observable<any[]> {
    const url = `${this.ucud_text_box}${param}`;
    return this.http.get<any[]>(url);
  }
  textBox(param:string): Observable<any[]> {
    const url = `${this.text_api}${param}`;
    return this.http.get<any[]>(url);
  }
  sync(param:string): Observable<any[]> {
    const url = `${this.sync_api}${param}`;
    return this.http.get<any[]>(url);
  }
  table(param:string): Observable<any[]> {
    const url = `${this.table_api}${param}`;
    return this.http.get<any[]>(url);
  }
  disease(param?:string): Observable<any[]> {
    const url = `${this.disease_api}${param}`;
    return this.http.get<any[]>(url);
  }
  hospital(param?:string): Observable<any[]> {
    const url = `${this.hospital_api}${param}`;
    return this.http.get<any[]>(url);
  }
  group100(param:string): Observable<any[]> {
    const url = `${this.grid_api}${param}`;
    return this.http.get<any[]>(url);
  }
  vn(param:string): Observable<any[]> {
    const url = `${this.vn_api}${param}`;
    return this.http.get<any[]>(url);
  }
  bubble(param:string): Observable<any[]> {
    const url = `${this.bubble_api}${param}`;
    return this.http.get<any[]>(url);
  }
  
}
